export default __webpack_public_path__ + "static/media/681.5c5f89f5.png";